import { render, staticRenderFns } from "./TextBox.vue?vue&type=template&id=71c43f78&scoped=true&"
import script from "./TextBox.vue?vue&type=script&lang=js&"
export * from "./TextBox.vue?vue&type=script&lang=js&"
import style0 from "./TextBox.vue?vue&type=style&index=0&id=71c43f78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c43f78",
  null
  
)

export default component.exports